import { DateTime } from 'luxon'

/**
 * アプリ既定の「いま」の JST。
 * DateTimeContext のデフォルト getNowJST と同じ定義（バリデーション等でフックを使えない箇所用）。
 */
export function getNowJst(): DateTime {
  return DateTime.now().setZone('Asia/Tokyo')
}
